// CurvesChartjs.js
import { useState, useEffect } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
} from 'chart.js'
import { Line } from 'react-chartjs-2'
import moment from 'moment'
import 'chartjs-adapter-moment'

ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
)
/**
 * 
 * @param {Array<string>} targets identifies the out_data keys used in this chart.
 * @param {JSON} out_data object containing time series data keyed by swmm object names.
 * @param {string} outputSection name of the 
 * @returns {JSX} Chart.js Line chart for displaying time-based results from a swmm .out file.
 */
export function CurvesChartjs({out_data, targets, model, titleText='', legendPos='top', spark=false, showDots=false}) {  
  const [labels, setLabels] = useState([])
  const [datasets, setDatasets] = useState([])

  // Returns a color from a random, unique color palette.
  const colorSet01 = (num) => {
    const color = (num + 12) * 137.508
    return `hsl(${color}, 50%, 40%)`
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip:{
        yAlign: 'bottom'
      },
      legend: {
        position: legendPos,
        labels: {
          boxWidth:spark?0:20, 
          font:{
            family:spark?"'Courier New', 'Courier', sans-serif":"'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            weight:spark?'bold':'normal',
            lineHeight:spark?0.9:1.2
          }
        },
      },
      title: {
        display: titleText.length?true:false,
        text: titleText
      },
    },
    scales: {
      y: {
        position: 'left',
        reverse: false
      },
      x:{
        type: 'linear',
        display: spark?false:true
      },
    },
  }

  useEffect(()=>{
    let keysAll = out_data?Object.keys(out_data):[]
    if(keysAll?.length > 0 && targets !== undefined ) {
      let labelData = []
      let maxObjs = 1000
      let rS1 = []

      // Create the datasets object.
      if(keysAll?.length > 0 && targets !== undefined ) {
        let datasets_maker = []
        // For each target in targets, create a data array if it exists in out_data
        targets.forEach((target, index) => {
          if(target in out_data){
            rS1[target] = []
            let keys = out_data[target]
            let keysLength = keys.length
            let falseStep = keysLength/maxObjs 

            if(falseStep < 1) falseStep = 1
            for(let i = 0; i < keysLength; i=i+Math.ceil(falseStep)){
              rS1[target].push(out_data[target][i].y)//[i][1])
              if(index===0){
                // If the dates are in a float point format, use them as 
                //"Hours from model.OPTIONS.START_DATE + model.OPTIONS.START_TIME"
                if (typeof out_data[target][i].x === 'string' && out_data[target][i].x.includes('-')){
                  labelData.push(moment(out_data[target][i].x/*[i][0]*/, 'MM/DD/YYYY HH:mm:ss').utc())
                } else {
                  // Get the start date and time
                  let startTime = out_data[target][i].x
                  labelData.push(startTime)
                }
              }
            }
            datasets_maker.push({
              label: spark?target.padEnd(9):target,
              yAxisID: 'y',
              data: rS1[target],
              backgroundColor: colorSet01(index),
              borderColor: colorSet01(index),
              pointRadius: spark||!showDots?0:3,
              borderWidth: spark||!showDots?2:3,
              pointHitRadius: 20,
            })
          }
        })
        
        setLabels(labelData)
        setDatasets(datasets_maker)
      }
    }
  },[out_data, targets, spark, showDots])

  const data = {
    labels,
    datasets: datasets
  }

  return (
    <Line options={options} data={data} />
  )
}
